module.exports = __webpack_public_path__ + "static/media/32.2ec34575.gif";